<div [style.minWidth]="minWidth" [style.minHeight]="minHeight">
  <div class="overlay" *ngIf="loading || hasError || noData">
    <div class="message" *ngIf="getMessage()">{{getMessage()}}</div>
    <img *ngIf="!loading && hasError" class="noData" [src]="errorImage || '/assets/images/undraw/warning.svg'" alt="error" />
    <img *ngIf="loading && loadingImage" class="loadingBackground" src="{{loadingImage}}" alt="loading background" />
    <div class="loading-template-container" *ngIf="loading">
      <ng-container [ngTemplateOutlet]="loadingTemplate"></ng-container>
    </div>
  </div>
  <div class="content-container" [class.loading]="loading">
    <ng-content></ng-content>
  </div>
</div>
